// extracted by mini-css-extract-plugin
export default {"tnButton":"TNDropDown_tnButton__-Fne3"};